/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import { takeLatest } from 'redux-saga/effects';
import { handleSavePersonalDetails } from './personalDetailsFormHandlers';
import { savePersonalDetails } from './personalDetailsFormSlice';

export function* savePersonalDetailsSaga() {
  yield takeLatest(savePersonalDetails.type, handleSavePersonalDetails);
}
